import React from 'react';
import { AssessmentLollipopChart as SharedChart } from 'js/components/Charts/AssessmentLollipopChart';
import { AxisBottom } from '../AxisBottom';
import { YearUnderlay } from '../YearUnderlay';

export const AssessmentLollipopChart = (props) => (
  <SharedChart {...props} AxisBottom={AxisBottom} YearUnderlay={YearUnderlay} />
);

export default AssessmentLollipopChart;
